import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h, Fragment } from 'vue';
import PullToRefresh from './Components/PullToRefresh.vue';
import SessionNotice from './Components/SessionNotice.vue';
import VueApexCharts from 'vue3-apexcharts';
import axios from 'axios';
import { router } from '@inertiajs/vue3';
import {
    isSessionFailureStatus,
    notePageVisited,
    noteRequestAccepted,
    reportSessionFailure,
    setPageUserResolver,
} from './utils/sessionRecovery';

const appName = import.meta.env.VITE_APP_NAME || '4Record';

// Session/CSRF failures are reported, never replayed and never answered with a reload, so unsaved
// input survives and a write cannot run twice. Inertia uses this Axios instance too; concurrent
// reports share one status check.
axios.interceptors.response.use(
    (response) => {
        noteRequestAccepted(response.config?.method, response.status);
        return response;
    },
    (error) => {
        const status = error?.response?.status;
        if (isSessionFailureStatus(status)) {
            reportSessionFailure(status);
        }
        return Promise.reject(error);
    },
);

router.on('invalid', (event) => {
    const status = event.detail.response?.status;
    if (isSessionFailureStatus(status)) {
        // Replaces Inertia's "Page Expired" overlay; the current page and its form state stay intact.
        event.preventDefault();
        reportSessionFailure(status);
    }
});

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob('./Pages/**/*.vue'),
        ),
    setup({ el, App, props, plugin }) {
        let currentPage = props.initialPage;
        router.on('navigate', (event) => {
            currentPage = event.detail.page;
            notePageVisited(new URL(event.detail.page.url, window.location.origin).pathname);
        });
        setPageUserResolver(() => currentPage?.props?.auth?.user);

        return createApp({
            render: () =>
                h(Fragment, null, [h(PullToRefresh), h(SessionNotice), h(App, props)]),
        })
            .use(plugin)
            .component('VueApexCharts', VueApexCharts)
            .mount(el);
    },
    progress: {
        color: '#dc2626', // primary-600
    },
});
